define('viewModels/privileged/composer/forms/qualityScore/QuestionGroupScore',[
    'lib/knockout',
    'viewModels/ViewModel',
    'viewModels/privileged/composer/forms/qualityScore/QuestionScore',
    'viewModels/privileged/composer/vmUtils'
], function (
    ko,
    ViewModel,
    QuestionScoreViewModel,
    utils
) {
    "use strict";

    var QuestionGroupScoreViewModel = ViewModel.extend(function qualityScoreResultVm_init(questionGroupScoreModel) {
        var self = this;

        // Returns the underlying model; used by the editor to save
        self.getModel = function () {
            return questionGroupScoreModel;
        };

        // Model Properties
        self.id = questionGroupScoreModel.questionGroupId;
        self.name = questionGroupScoreModel.groupName;
        self.modelId = questionGroupScoreModel.modelId;
        self.totalScore = questionGroupScoreModel.totalScore;
        self.maxTotalScore = questionGroupScoreModel.maxTotalScore;
        self.totalCriticalScore = questionGroupScoreModel.totalCriticalScore;
        self.maxTotalCriticalScore = questionGroupScoreModel.maxTotalCriticalScore;
        self.hasCriticalScore = ko.observable(true);

        // The question groups associated with this evaluation
        self.questionScores = utils.subviewList(self, questionGroupScoreModel.questionScores, QuestionScoreViewModel);

        // If the total Critical Score is 0 then we don't need to show the values in the summary
        if(self.maxTotalCriticalScore() === 0){
            self.hasCriticalScore(false);
        }
        // Computed display score
        self.displayScore = function() {
            return ko.i18n.renderString('composer.evaluations.scoring.groupScoreValue',
                { score: self.totalScore().toFixed(2),
                  maxScore: self.maxTotalScore().toFixed(2)
                });
        };

        self.displayCriticalScore = function() {
            return ko.i18n.renderString('composer.evaluations.scoring.groupScoreCriticalValue',
                {
                    critScore: self.totalCriticalScore().toFixed(2),
                    maxCritScore: self.maxTotalCriticalScore().toFixed(2)
                });
        };

    });
    return QuestionGroupScoreViewModel;
});

